import React, { FC } from "react";
import { Updater, useImmer } from "use-immer";

import {
  ColorDisabled,
  ColorSecondary,
  IgButton,
  IgRadio,
  IgSelect,
  IgTextField,
} from "@intelligems/ig-theme";
import {
  FormControlLabel,
  FormLabel,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
} from "@mui/material";

import theme from "../../../../theme";
const feedbackTypes = [
  "Twitter",
  "LinkedIn",
  "Podcast",
  "Web search",
  "Shopify App Store",
  "Event (specify)",
  "eCommerce Fuel",
  "Agency referral (specify)",
  "Other referral (specify)",
  "Other (specify)",
];
interface FindIntelligemsProps {
  selectedType: string;
  setSelectedType: Updater<string>;
  specifyValue: string;
  setSpecifyValue: Updater<string>;
  handleNext: () => void;
}
export const FindIntelligems = ({
  setSpecifyValue,
  specifyValue,
  setSelectedType,
  selectedType,
  handleNext,
}: FindIntelligemsProps) => {
  return (
    <Grid
      container
      item
      direction={"column"}
      justifyContent={"center"}
      alignItems={"center"}
      rowSpacing={2}
    >
      <Grid item>
        <IgSelect
          fullWidth={true}
          onChange={(e) => {
            setSelectedType(e.target.value as string);
          }}
          sx={{ width: "400px" }}
          value={selectedType === "" ? "ig-empty" : selectedType}
          placeholder={"Please choose one"}
        >
          {feedbackTypes.map((type) => (
            <MenuItem key={type} value={type}>
              {type}
            </MenuItem>
          ))}
        </IgSelect>
      </Grid>
      {selectedType.includes("specify") && (
        <Grid item>
          <IgTextField
            rows={3}
            multiline={true}
            sx={{ width: "400px" }}
            placeholder={"Please provide more detail"}
            value={specifyValue}
            onChange={(e) => {
              setSpecifyValue(e.target.value);
            }}
          />
        </Grid>
      )}
      <Grid item>
        <IgButton
          onClick={handleNext}
          sx={{ fontSize: "16px", width: "215px" }}
          variant={"contained"}
        >
          Let's Go
        </IgButton>
      </Grid>
    </Grid>
  );
};
